(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-ugc-videos"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.myUGCswiper', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  centeredSlides: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

  breakpoints: {
    0: { slidesPerView: 1.2 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 }
  },

  on: {
    init: function () {
      handleVideos(this);
    },

    slideChangeTransitionEnd: function () {
      handleVideos(this);
    }
  }
});

function handleVideos(swiper) {

  // pause all videos first
  document.querySelectorAll('.myUGCswiper video').forEach(video => {
    video.pause();
    video.currentTime = 0;
  });

  // get active slide video
  const activeSlide = swiper.slides[swiper.activeIndex];
  if (!activeSlide) return;

  const activeVideo = activeSlide.querySelector('video');

  if (activeVideo) {

    // play safely
    const playPromise = activeVideo.play();

    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.log('Video autoplay prevented:', error);
      });
    }
  }
}

// ✅ Sound toggle
document.querySelectorAll('.sound-toggle').forEach(btn => {

  btn.addEventListener('click', function () {

    const video = this.previousElementSibling;

    if (!video) return;

    if (video.muted) {
      video.muted = false;
      this.textContent = "🔊";
    } else {
      video.muted = true;
      this.textContent = "🔇";
    }

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videoslider"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.myUGCswiper', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  centeredSlides: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

  breakpoints: {
    0: { slidesPerView: 1.2 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 }
  },

  on: {
    init: function () {
      handleVideos(this);
    },

    slideChangeTransitionEnd: function () {
      handleVideos(this);
    }
  }
});

function handleVideos(swiper) {

  const activeSlide = swiper.slides[swiper.activeIndex];

  if (!activeSlide) return;

  const activeVideo = activeSlide.querySelector('video');

  document.querySelectorAll('.myUGCswiper video').forEach(video => {

    if (video !== activeVideo) {

      video.pause();
      video.currentTime = 0;

    }

  });

  if (!activeVideo) return;

  if (!activeVideo.paused) return;

  const playVideo = async () => {

    try {

      if (activeVideo.readyState < 2) {

        await new Promise(resolve => {

          activeVideo.addEventListener(
            'loadeddata',
            resolve,
            { once: true }
          );

        });

      }

      await activeVideo.play();

    } catch (error) {

      console.log('Autoplay prevented:', error);

    }

  };

  setTimeout(() => {
    playVideo();
  }, 150);

}

// Sound toggle
document.querySelectorAll('.sound-toggle').forEach(btn => {

  btn.addEventListener('click', function () {

    const video = this.previousElementSibling;

    if (!video) return;

    if (video.muted) {

      video.muted = false;
      this.textContent = "🔊";

    } else {

      video.muted = true;
      this.textContent = "🔇";

    }

  });

});

  } catch(e) { console.error(e); }
})();
})();
